var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassengers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF66F4EC-8DE7-4104-BD19-61BE9AABC0BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-124.000000, -1067.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "passengers",
    transform: "translate(124.000000, 1065.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5741919,21 L16.423153,21 C17.6163731,21 18.3676598,19.7644259 17.8152431,18.7456192 C17.019763,17.271601 15.6718663,16.1660873 14.0367128,15.6891991 L12.1143027,15.1256039 C11.4514026,14.9305132 11.0978559,14.2368576 11.3409193,13.6082322 C11.3851126,13.4781717 11.4514026,13.3481113 11.5397893,13.2614044 L12.9097827,11.7440327 C13.8157461,10.7252259 14.2576795,9.38126816 14.1030028,8.03731037 L13.8820361,6.1947876 C13.7052628,4.7857996 12.9097827,3.52854876 11.694466,2.76986292 L11.6723693,2.74818618 C10.0593125,1.72937947 7.96012904,1.75105621 6.36916892,2.81321639 C5.2643355,3.5502255 4.51304878,4.69909264 4.31417877,5.99969695 L4.00482541,7.92892668 C3.78385873,9.33791468 4.20369543,10.7469027 5.17594883,11.8090629 L6.47965226,13.2397276 C6.56803893,13.3481113 6.63432894,13.456495 6.67852228,13.5865554 C6.89948896,14.2151808 6.54594227,14.9088365 5.90513889,15.1039271 L3.98272874,15.6891991 C2.34757529,16.1660873 0.977581857,17.271601 0.182101799,18.7456192 C-0.370314908,19.7644259 0.403068482,21 1.5741919,21 Z",
    id: "Shape-Copy-5",
    fill: "#262728"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengers);
export default __webpack_public_path__ + "static/media/passengers.fcde863af3b2b654a32444ee5c6273a0.svg";
export { ForwardRef as ReactComponent };